import './App.css';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Location from './Components/Location';
import Details from './Components/Details';
import Appointment from './Components/Appointment';
function App() {
  return (
    <div >
  
  <Router>
        <Switch>

          <Route path="/" exact component={Details} />
          <Route path="/details">
            <Details/>
          </Route>
          <Route path="/address">
            <Location/>
          </Route>
          <Route path="/appointment">
            <Appointment/>
          </Route>
        </Switch>
      </Router>
      

    </div>
  );
}

export default App;
